import { z } from 'zod';
import { LocalDateCodec } from './codecs.js';
export const symbolSchema = z
    .string()
    .min(1)
    .meta({
    description: 'Instrument symbol',
    errorMessage: {
        type: 'Instrument symbol must be passed as a string',
        minLength: 'Instrument symbol must be a non-empty string',
    },
});
export const EquityInstrument = z
    .object({
    type: z.literal('equity').meta({
        description: "Equity instrument 'type' must be defined as 'equity'",
        errorMessage: "'type' must be defined as 'equity' for equity instrument",
    }),
    symbol: symbolSchema,
})
    .meta({
    $id: '#/$defs/generic/equityInstrument',
    description: 'EquityInstrument',
    errorMessage: {
        required: {
            type: "'type': 'equity' property must be defined for equity instrument",
            symbol: "'symbol' string property must be defined for equity instrument",
        },
        type: "'type' must be 'equity' for equity instrument",
        symbol: "'symbol' must be a valid non-empty string for equity instrument",
    },
});
export const OptionRight = z.union([z.literal('call'), z.literal('put')]).meta({ useOneOf: true });
export const OptionInstrument = z
    .object({
    type: z.literal('option').meta({
        description: "Option instrument 'type' must be defined as 'option'",
        errorMessage: "'type' must be defined as 'option' for option instrument",
    }),
    underlyingInstrument: EquityInstrument,
    strike: z.number(),
    expiry: LocalDateCodec,
    right: OptionRight,
})
    .meta({
    $id: '#/$defs/generic/optionInstrument',
    description: 'OptionInstrument',
    errorMessage: {
        required: {
            type: "'type': 'option' property must be defined for option instrument",
            underlyingInstrument: "'underlyingInstrument' must be provided for an option",
            strike: "'strike' must be provided for an option",
            expiry: "'expiry' must be provided for an option",
            right: "'right' must be provided in an option",
        },
        strike: "'strike' must be a valid number for an option instrument",
        expiry: "'expiry' must be a valid ISO 8601 date string for an option instrument",
        right: "'right' must be either 'call' or 'put'",
        underlyingInstrument: "'underlyingInstrument' must be a valid equity or option instrument",
    },
});
export const Instrument = z.discriminatedUnion('type', [OptionInstrument, EquityInstrument]).meta({
    $id: '#/$defs/generic/instrument',
    errorMessage: 'Instrument must be either a valid equity or option instrument',
});
//# sourceMappingURL=instruments.js.map